import React from "react";

import { ScheduledActivitiesCard } from "@/components/settings/ScheduledActivitiesCard";
import { AutomationsCard } from "@/components/settings/AutomationsCard";

export const PersonalAutomationSettings: React.FC = () => (
  <section
    aria-labelledby="personal-automation-settings"
    className="space-y-3"
  >
    <div>
      <h2 id="personal-automation-settings" className="text-xl font-semibold">
        Personal automation
      </h2>
      <p className="text-sm text-muted-foreground">
        Manage automations and scheduled activities created for your personal
        workspace.
      </p>
    </div>
    <div className="grid gap-6">
      <ScheduledActivitiesCard />
      <AutomationsCard mode="personal" />
    </div>
  </section>
);
